module.exports = __webpack_public_path__ + "static/media/delete.c7c58f88.svg";